define('pwa/plugin/multiple-booking/view/MultipleBookingLayoutView',['require','marionette','plugin/multiple-booking/view/MultipleBookingListView'],function (require) {

    var Marionette = require('marionette');
    var MultipleBookingListView = require('plugin/multiple-booking/view/MultipleBookingListView');

    /**
     * Multiple booking layout
     *
     * @class MultipleBookingLayoutView
     */
    return Marionette.LayoutView.extend({

        template: '#multiple_booking_layout_view',

        regions: {
            multipleBookingList: '#sb_multiple_booking_list_page',
        },

        ui: {
            multipleBookingCheckout: '#sb_multiple_booking_checkout'
        },

        triggers: {
            'click @ui.multipleBookingCheckout': {
                'event': 'checkout',
                'stopPropagation': false,
                'preventDefault': false
            }
        },

        collectionEvents: {
            'remove': 'onRemoveCollectionEvent',
        },

        onBeforeShow: function () {
            this.showChildView('multipleBookingList', new MultipleBookingListView({
                'collection': this.getOption('collection'),
            }));
        },

        onRemoveCollectionEvent: function () {
            if (!this.getOption('collection').length) {
                this.ui.multipleBookingCheckout.hide();
            }
        },
    });

});
